__turbopack_context__.v({
  "root": "BottomBar-module__7DYtta__root",
});
